"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterMaxValueInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const types_1 = require("@framework/types");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_picker_1 = require("@dzambalaorg/mui-inputs-picker");
const ParameterMaxValueInput = (props) => {
    const { name = "parameterMaxValue" } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const parameterType = (0, react_hook_form_1.useWatch)({ name: `parameterType` });
    (0, react_1.useEffect)(() => {
        if (parameterType === types_1.ParameterType.NUMBER || parameterType === types_1.ParameterType.STRING) {
            form.setValue(name, 50);
        }
        else if (parameterType === types_1.ParameterType.DATE) {
            form.setValue(name, new Date().toISOString());
        }
        else {
            form.setValue(name, "");
        }
    }, [parameterType]);
    switch (parameterType) {
        case types_1.ParameterType.STRING:
        case types_1.ParameterType.NUMBER: {
            return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.NumberInput, { name: name, inputProps: { min: 0 } });
        }
        case types_1.ParameterType.DATE: {
            return (0, jsx_runtime_1.jsx)(mui_inputs_picker_1.DateTimeInput, { name: name });
        }
        default: {
            return null;
        }
    }
};
exports.ParameterMaxValueInput = ParameterMaxValueInput;
//# sourceMappingURL=index.js.map